import { defineMessages } from '@transcend-io/internationalization';

export const downloadZipButtonMessages = defineMessages(
  'pc-core-components.DownloadZipButton.downloadZipButton',
  {
    download: {
      defaultMessage: 'Download Archive',
    },
    saving: {
      defaultMessage: 'Downloading files to disk...',
    },
    downloaded: {
      defaultMessage: 'Downloaded to disk!',
    },
  },
);
